import a from "../../../@babel/runtime/helpers/esm/objectSpread2.mjs";
import * as r from "react";
import B from "../../../classnames/index.mjs";
import { composeRef as $ } from "../../../rc-util/es/ref.mjs";
import { warning as q } from "../../../rc-util/es/warning.mjs";
var z = function(o, y) {
  var p, l, b = o.prefixCls, u = o.id, h = o.inputElement, x = o.disabled, D = o.tabIndex, v = o.autoFocus, f = o.autoComplete, e = o.editable, E = o.activeDescendantId, I = o.value, S = o.maxLength, N = o.onKeyDown, K = o.onMouseDown, M = o.onChange, O = o.onPaste, L = o.onCompositionStart, P = o.onCompositionEnd, R = o.open, F = o.attrs, i = h || /* @__PURE__ */ r.createElement("input", null), d = i, j = d.ref, t = d.props, m = t.onKeyDown, c = t.onChange, C = t.onMouseDown, g = t.onCompositionStart, w = t.onCompositionEnd, k = t.style;
  return q(!("maxLength" in i.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled."), i = /* @__PURE__ */ r.cloneElement(i, a(a(a({
    type: "search"
  }, t), {}, {
    // Override over origin props
    id: u,
    ref: $(y, j),
    disabled: x,
    tabIndex: D,
    autoComplete: f || "off",
    autoFocus: v,
    className: B("".concat(b, "-selection-search-input"), (p = i) === null || p === void 0 || (l = p.props) === null || l === void 0 ? void 0 : l.className),
    role: "combobox",
    "aria-expanded": R,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(u, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(u, "_list"),
    "aria-activedescendant": E
  }, F), {}, {
    value: e ? I : "",
    maxLength: S,
    readOnly: !e,
    unselectable: e ? null : "on",
    style: a(a({}, k), {}, {
      opacity: e ? null : 0
    }),
    onKeyDown: function(n) {
      N(n), m && m(n);
    },
    onMouseDown: function(n) {
      K(n), C && C(n);
    },
    onChange: function(n) {
      M(n), c && c(n);
    },
    onCompositionStart: function(n) {
      L(n), g && g(n);
    },
    onCompositionEnd: function(n) {
      P(n), w && w(n);
    },
    onPaste: O
  })), i;
}, A = /* @__PURE__ */ r.forwardRef(z);
A.displayName = "Input";
export {
  A as default
};
//# sourceMappingURL=Input.mjs.map
